import { Component, input, model } from '@angular/core';

@Component({
  selector: 'rid-egg-carton',
  templateUrl: 'rid-egg-carton.html',
  imports: [],
})
export class RidEggCarton {
  public readonly eggs = model<number>(0);
  public readonly fixedEggs = input<number>(0);
  public readonly changeable = input(true);
  public readonly fixedFillColor = input('#10b981');
  public readonly fillColor = input('#10b981');
}
